


















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Base } from '@/components/common/base';
import { Utils } from '@/helper/utils';
import { loadButlerBlocks } from 'butler-blocks';
import { DocumentLabelerOutputDataDto } from 'butler-blocks/lib/common/types/DocumentLabelerTypes';
import { expenseService } from '@/shared';

@Component({
  props: ['methodName', 'progress', 'IsFutureDate'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    SnackBarLoader: () => import('@/components/common/loader.vue'),
  },
})

export default class ButlerBlockPage extends Base {
  public loading: boolean = false;
  public attachmentUri: string = "";
  public ocrToken: string = "";
  public buttons: any = [];
  public showLoading: boolean = false;

  public myDocument = {
    modelId: '',
    documentId: '',
  };

  public myApiKey = Utils.ButlerApiKey;
  public butlerBlocks = loadButlerBlocks(this.myApiKey);

  public async created() {
    this.myDocument.modelId = Utils.ButlerModleId;
    this.myDocument.documentId = this.$route.params.documentId;
  }

  public mounted(): void {
    this.attachmentUri = this.$route.params.uri;
    this.ocrToken = this.$route.params.impiraUid;

    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    // Toolbar
    this.updateToolBar();
    this.initializeDocLabeler(this.myDocument);
  }

  public callMethod(methodName): void {
    if (methodName === 'back') {
      history.back();
    }
    this.resetMethodName(methodName);
  }

  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }

  public async fetchDocumentData(modelId, documentId) {
    try {
      this.loading = true;
      const extractionResultsResponse = await this.butlerBlocks.api.getExtractionResults(modelId, documentId);
      return extractionResultsResponse.data;
    } finally {
      this.loading = false;
    }
  }

  public async submitLabels(trainingDocumentLabels) {
    try {
      this.showAlert(true, 'Request has been Initiated for Saving Details, please while we process.');

      var ocrFormFields = [];
      trainingDocumentLabels.results.fields.forEach(function (item) {
        var fieldData = trainingDocumentLabels.formFields.filter(x => x.fieldName == item.name)[0];
        item.value = fieldData.value;

        if (item.name && item.value) {
          ocrFormFields.push({
            fieldName: item.name,
            value: item.value
          });
        }
      });

      // try {
      //   await this.butlerBlocks.api.submitDocumentLabels(this.myDocument.modelId, this.myDocument.documentId, trainingDocumentLabels.results);
      // } catch (e) {
      //   console.log(e);
      // }

      this.showLoading = true;
      this.buttons[0].disabled = true;

      await expenseService.submitButlerDocument(
        this.userSession.tenantId,
        this.userSession.enterpriseId,
        this.userSession.storeId,
        this.attachmentUri,
        this.ocrToken,
        ocrFormFields
      );

      this.showAlert(true, 'Document Mapping updated Successfully.');

      this.$router.push({ name: 'app.expenses.attachment'});
    } finally {
      this.showLoading = false;
      this.buttons[0].disabled = false;
    }
  }

  public async initializeDocLabeler({ modelId, documentId }) {
    const butlerOcrDetails = await this.fetchDocumentData(modelId, documentId);
    this.butlerBlocks.createDocLabeler('ButlerDocumentLabeler', butlerOcrDetails, {
      saveActionButtonText: 'Save',
      displayOnly: false,
      hideSaveButton: false,
      // onLabelUpdate: (docInfo: DocumentLabelerOutputDataDto) => {
      // },
      onSaveCallback: (updatedData: DocumentLabelerOutputDataDto) => {
        updatedData.trainingDocumentLabels.docId = this.myDocument.documentId;
        this.submitLabels(updatedData.extractionResult);
      }
    });
  }

  public updateToolBar(): void {
    this.buttons.push({
      id: '0',
      type: 'button',
      title: this.$t('apSearchReport.btnTitleBackToList'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$t('apSearchReport.btnBack'),
      click: 'back',
      icon: 'fas fa-arrow-left',
      requestProgress: true,
    });
    this.$emit('updateToolBar', this.buttons);
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
}
